import { connect } from 'react-redux';

import StoryModule from 'components/StoryModule';
import { PDP_STORY_MODULE_VISIBILITY } from 'constants/pdp';
import { CAMPAIGN_NAMES } from 'constants/personalizations';
import * as actions from 'state/actions';
import PersonalizationsSelector from 'state/selectors/personalizations';

const setVisibilityFlags = (visibilityFlags = []) => {
  const flags = {
    isHidden: false,
    showOnMobile: false,
    showOnDesktop: false,
  };

  visibilityFlags.forEach(flag => {
    if (flag === PDP_STORY_MODULE_VISIBILITY.HIDDEN) flags.isHidden = true;
    if (flag === PDP_STORY_MODULE_VISIBILITY.MOBILE) flags.showOnMobile = true;
    if (flag === PDP_STORY_MODULE_VISIBILITY.DESKTOP) flags.showOnDesktop = true;
  });

  flags.showOnMobile = flags.showOnMobile && !flags.isHidden;
  flags.showOnDesktop = flags.showOnDesktop && !flags.isHidden;

  return flags;
};

const getVariationData = (state, campaignName) => {
  const campaign = PersonalizationsSelector.getCampaignByName(state, campaignName);
  return campaign?.variations?.[0] ?? {};
};

const mapStateToProps = (state, { data, modulePosition, ...ownProps }) => {
  const {
    visibility,
    heading,
    mobileCardLayout,
    internalName,
    storyModuleCards,
    posterDimensions,
  } = data || {};
  const { showOnDesktop, showOnMobile } = setVisibilityFlags(visibility);

  const contentExperimentVariation = getVariationData(
    state,
    CAMPAIGN_NAMES.PDP_STORY_MODULE_CONTENT
  );
  const activeItems = contentExperimentVariation.payload?.data?.items ?? [];

  const showModule =
    activeItems.some(item => item.trim() === internalName?.trim()) ||
    !Object.keys(contentExperimentVariation).length;

  return {
    ...ownProps,
    heading,
    internalName,
    mobileCardLayout,
    storyModuleCards,
    posterDimensions,
    modulePosition,
    showModule,
    showOnDesktop,
    showOnMobile,
  };
};

const mapDispatchToProps = {
  openModal: url => dispatch => {
    dispatch(actions.setPdpVideoModalUrl(url));
    dispatch(actions.openPdpVideoModal());
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(StoryModule);
